import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { InfoBlock, InfoBlockTypes } from '@gem/ui-kit';

import { friendsSpaceImagesEmptyConfig } from './FriendsSpaceMessagesEmpty.config';
import styles from './FriendsSpaceMessagesEmpty.styles.m.css';

interface IFriendsSpaceMessagesEmptyProps {
  avatarUrl: string;
}

export const FriendsSpaceMessagesEmpty: FC<IFriendsSpaceMessagesEmptyProps> = ({ avatarUrl }) => {
  const config = friendsSpaceImagesEmptyConfig[avatarUrl];
  const { t } = useTranslation();

  if (!config) {
    return null;
  }

  return (
    <InfoBlock
      className={styles.infoBlock}
      type={InfoBlockTypes.Chat}
      title={t(config.titleKey)}
      descriptions={[t(config.descriptionKey)]}
      image={config.image}
    />
  );
};
